import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../shared/reducers/index.tx';
import { getGamificationProfileAction } from '../../shared/actions/gamification.actions';
import { GamificationService } from '../../shared/gamification.service';

@Component({
  selector: 'lp2-error-ticket',
  templateUrl: './error-ticket.component.html',
  styleUrls: ['./error-ticket.component.scss'],
})
export class ErrorTicketComponent {
  constructor(
    private store: Store<AppState>,
    private gamificationService: GamificationService
  ) {}

  tryAgain(): void {
    this.store.dispatch(getGamificationProfileAction());
    this.gamificationService.startRefreshGamification();
  }
}



// WEBPACK FOOTER //
// ./ts/app/progress/error-ticket/error-ticket.component.ts